import {
  Button,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";

import React from "react";
import { useForm } from "@formspree/react";
import { FiMail, FiUser } from "../../customIcons";

function Newsletter() {
  const toast = useToast();

  const [state, handleSubmit] = useForm("mpzgnwan");

  if (state.succeeded) {
    toast({
      status: "success",
      title: "You have subscribed to our newsletter!",
    });
  }

  return (
    <Stack
      gap={0}
      mx="auto"
      justifyContent="space-between"
      p="20px"
      borderRadius="10px"
      bg="#BB5D82"
      width="100%"
      maxW="1280px"
      flexDir={{ base: "column", md: "row" }}
    >
      <VStack alignItems="flex-start">
        <Text fontSize="16px" fontWeight="700" color="#fff">
          Newsletter
        </Text>
        <Text pb={{ base: "16px", lg: "0px" }} fontSize="16px" color="#ffff">
          Subscribe for exclusive offers and updates on new arrivals
        </Text>
      </VStack>
      <form onSubmit={handleSubmit}>
        <HStack
          gap={2}
          flexDir={{ base: "column", md: "column", lg: "row" }}
          alignItems="flex-start"
        >
          <InputGroup flex={1}>
            <InputLeftElement
              pointerEvents="none"
              color="gray.400"
              fontSize="lg"
              h="100%"
              my="auto"
            >
              <FiUser color="#CB809E" />
            </InputLeftElement>
            <Input
              id="name"
              type="text"
              maxW="100%"
              w={{ base: "100%", md: "303px" }}
              name="name"
              required
              placeholder="Your Name *"
              rounded="md"
              textColor="#4A5568"
              borderColor="#A0AEC0"
              focusBorderColor="#BB5D82"
              bg="#fff"
              h="48px"
            />
          </InputGroup>

          <InputGroup flex={1}>
            <InputLeftElement
              pointerEvents="none"
              color="gray.400"
              fontSize="lg"
              h="100%"
              my="auto"
            >
              <FiMail color="#CB809E" />
            </InputLeftElement>
            <Input
              id="email"
              type="email"
              name="email"
              required
              w={{ base: "100%", md: "303px" }}
              maxW="100%"
              placeholder="Your Email *"
              rounded="md"
              textColor="#4A5568"
              borderColor="#A0AEC0"
              focusBorderColor="#BB5D82"
              bg="#fff"
              h="48px"
            />
          </InputGroup>
        </HStack>
        <Button
          mt={{ base: "12px", md: "8px" }}
          w={"140px"}
          h="48px"
          variant="outline"
          _hover={{ bg: "#DBA4B9" }}
          fontSize="18px"
          color="#fff"
          fontWeight="600"
          type="submit"
          disabled={state.submitting}
        >
          Subscribe
        </Button>
      </form>
    </Stack>
  );
}

export default Newsletter;
